// src/pages/Vouchers/CustomerReceiptForm.jsx
import React from 'react';
import VoucherForm, { VOUCHER_CONFIGS } from './VoucherForm';

export default function CustomerReceiptForm() {
  return <VoucherForm config={VOUCHER_CONFIGS.customerReceipt} />;
}
